<template>
      <div class="pageCreate">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'page', params: {} }">
          Page
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'pageCreate', params: {} }">
            Create Page
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Create Page</v-card-title>
          <v-card-text>
            <page-form></page-form>
          </v-card-text>
        </v-card>
      </div>
    </template>
    <script>
    import PageForm from './PageForm.vue';

    export default {
      name: 'page',
      components: {
        PageForm
      },
      created() {
        this.$emit("showParent", false);
      }
    }
    </script>
    